import type {StateCreator} from 'zustand'
import type {DiffAnnotation, Thread} from '@github-ui/conversations'

export type Markers = {
  threads: {[id: number]: Thread}
  annotations: {[id: number]: DiffAnnotation}
}

export interface MarkersSliceOpts {
  markers?: Markers | undefined
}

type MarkersSliceState = {
  markers?: Markers
}
type MarkersSliceActions = {}
export type MarkersSlice = MarkersSliceState & MarkersSliceActions

export const createMarkersSlice =
  ({markers}: MarkersSliceOpts): StateCreator<MarkersSlice, [['zustand/devtools', never]], [], MarkersSlice> =>
  () => ({
    markers,
  })
